import BooleanColumn, { cellType, booleanColumnConfiguration } from './BooleanColumn.component';

export { cellType, BooleanColumn };
export default booleanColumnConfiguration;
